import React, { useState } from "react";

const ClientForm = ({ onSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [acceptPrivacy, setAcceptPrivacy] = useState(false);
  const [acceptMarketing, setAcceptMarketing] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // The privacy notice is mandatory; marketing consent is optional.
    if (name && email && phone && postalCode && acceptPrivacy) {
      onSubmit({
        name,
        email,
        phone,
        postal_code: postalCode,
        marketing: acceptMarketing ? 1 : 0,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Nome"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Telefone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Código Postal"
        value={postalCode}
        onChange={(e) => setPostalCode(e.target.value)}
        required
      />
      <label htmlFor="privacy-checkbox" className="checkbox-container">
          <input
            id="privacy-checkbox"
            type="checkbox"
            checked={acceptPrivacy}
            onChange={(e) => setAcceptPrivacy(e.target.checked)}
            required
          />
          <span className="custom-checkmark"></span>
          <div className="checkbox-label-content">Li e compreendo o&nbsp;<a href="https://www.valorsul.pt/pt/footer-links/aviso-de-privacidade/" target="_blank" rel="noreferrer noopener">aviso de privacidade</a></div>
      </label>

      <label htmlFor="marketing-checkbox" className="checkbox-container">
          <input
            id="marketing-checkbox"
            type="checkbox"
            checked={acceptMarketing}
            onChange={(e) => setAcceptMarketing(e.target.checked)}
          />
          <span className="custom-checkmark"></span>
          <div className="checkbox-label-content">Aceito receber comunicações de marketing relacionadas com esta ou outra ação.</div>
      </label>
      <button type="submit">Começar</button>
    </form>
  );
};

export default ClientForm;
